import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box, Alert, CircularProgress } from '@mui/material';
import { Icon } from '@iconify/react';
interface CancelTransactionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
  transactionId: string;
  cancellationAction: string;
}
const CancelTransactionDialog: React.FC<CancelTransactionDialogProps> = ({
  open,
  onClose,
  onConfirm,
  transactionId,
  cancellationAction
}) => {
  const [reason, setReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const handleConfirm = async () => {
    if (!reason.trim()) {
      setError('Cancellation reason is required');
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      await onConfirm(reason);
      setReason('');
      onClose();
    } catch (err) {
      setError('Failed to submit cancellation request');
    } finally {
      setIsLoading(false);
    }
  };
  const handleClose = () => {
    if (!isLoading) {
      setReason('');
      setError(null);
      onClose();
    }
  };
  return <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth data-id="element-353">
      <DialogTitle data-id="element-354">
        <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }} data-id="element-355">
          <Icon icon="lucide:alert-triangle" width={24} color="#EF4444" data-id="element-356" />
          <Typography variant="h6" fontWeight={600} data-id="element-357">
            Cancel Transaction
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent data-id="element-358">
        <Box sx={{
        mt: 1
      }} data-id="element-359">
          <Typography variant="body2" color="text.secondary" sx={{
          mb: 2
        }} data-id="element-360">
            Transaction ID: <strong data-id="element-361">{transactionId}</strong>
          </Typography>

          <Alert severity="warning" sx={{
          mb: 2
        }} data-id="element-362">
            <Typography variant="body2" fontWeight={600} data-id="element-363">
              Action: {cancellationAction.replace(/_/g, ' ')}
            </Typography>
          </Alert>

          <TextField label="Cancellation Reason" placeholder="Enter reason for cancellation..." multiline rows={4} fullWidth required value={reason} onChange={e => {
          setReason(e.target.value);
          setError(null);
        }} error={!!error} helperText={error} disabled={isLoading} data-id="element-364" />
        </Box>
      </DialogContent>
      <DialogActions sx={{
      px: 3,
      pb: 2
    }} data-id="element-365">
        <Button onClick={handleClose} disabled={isLoading} data-id="element-366">
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleConfirm} disabled={isLoading || !reason.trim()} startIcon={isLoading ? <CircularProgress size={16} color="inherit" data-id="element-368" /> : <Icon icon="lucide:x-circle" width={16} data-id="element-369" />} data-id="element-367">
          Submit Cancellation
        </Button>
      </DialogActions>
    </Dialog>;
};
export default CancelTransactionDialog;